document.addEventListener('DOMContentLoaded', () => {
  initPakshopThemeToggle(document);
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.querySelector('[data-mobile-nav]');
      const open = nav?.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    control.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Math.min(99, parseInt(input.value || '1', 10) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-bundle]').forEach((bundle) => {
    bundle.addEventListener('click', () => {
      document.querySelectorAll('[data-bundle]').forEach((item) => item.classList.remove('is-selected'));
      bundle.classList.add('is-selected');
      const radio = bundle.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      const bundleQuantity = bundle.dataset.bundleQuantity;
      if (bundleQuantity) document.querySelectorAll('input[name="quantity"]').forEach((input) => { input.value = bundleQuantity; });
    });
  });

  initPakshopInlineSearch(document);
  initPakshopButtonMotion(document);
  initPakshopCategoryCarousels(document);
  initPakshopCategoryFilters(document);
  initPakshopReviewSliders(document);
  initPakshopAnnouncementTickers(document);
  initPakshopCartRemoveButtons(document);
  initPakshopCartLiveUpdates(document);
  initPakshopFavorites(document);
});

function initPakshopThemeToggle(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  const toggles = Array.from(root.querySelectorAll('[data-theme-toggle]'));
  if (!toggles.length) return;

  const storageKey = 'rimsal:theme';
  let savedTheme = '';
  try { savedTheme = window.localStorage.getItem(storageKey) || ''; } catch (error) {}

  const setTheme = (theme, persist = true) => {
    const isDark = theme === 'dark';
    document.documentElement.dataset.theme = isDark ? 'dark' : 'light';
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light';
    if (persist) {
      try { window.localStorage.setItem(storageKey, isDark ? 'dark' : 'light'); } catch (error) {}
    }

    toggles.forEach((button) => {
      const darkLabel = button.dataset.themeDarkLabel || button.getAttribute('aria-label') || 'Toggle dark mode';
      const lightLabel = button.dataset.themeLightLabel || 'Switch to light mode';
      const moon = button.querySelector('[data-theme-icon="moon"]');
      const sun = button.querySelector('[data-theme-icon="sun"]');
      const textLabel = button.querySelector('[data-theme-text]');
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.setAttribute('aria-label', isDark ? lightLabel : darkLabel);
      button.setAttribute('title', isDark ? lightLabel : darkLabel);
      button.classList.toggle('is-dark', isDark);
      if (textLabel) textLabel.textContent = isDark ? lightLabel : darkLabel;
      if (moon) moon.hidden = isDark;
      if (sun) sun.hidden = !isDark;
    });

    const themeColor = document.querySelector('meta[name="theme-color"]');
    if (themeColor) themeColor.content = isDark ? '#101614' : (themeColor.dataset.lightColor || themeColor.content);
  };

  toggles.forEach((button) => {
    if (button.dataset.pakshopThemeToggleReady === 'true') return;
    button.dataset.pakshopThemeToggleReady = 'true';
    button.addEventListener('click', () => {
      const isDark = document.documentElement.dataset.theme === 'dark';
      setTheme(isDark ? 'light' : 'dark');
    });
  });

  setTheme(savedTheme === 'dark' ? 'dark' : 'light', false);
}

function initPakshopButtonMotion(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('.pakshop-product-form button[type="submit"], .pakshop-product-buy-form button[type="submit"], #PakshopRuntimeForm button[type="submit"], #PakshopRuntimeBuyForm button[type="submit"]').forEach((button) => {
    if (button.dataset.pakshopButtonMotionReady === 'true') return;
    button.dataset.pakshopButtonMotionReady = 'true';
    button.addEventListener('click', () => {
      if (button.disabled) return;
      button.classList.remove('is-clicking');
      void button.offsetWidth;
      button.classList.add('is-clicking');
      window.setTimeout(() => button.classList.remove('is-clicking'), 650);
    });
  });
}

function initPakshopFavorites(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  const storageKey = 'rimsal:favorites:v1';
  const readFavorites = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter(item => item && item.id).map(item => ({ ...item, title: item.title || '', handle: item.handle || '' })) : [];
    } catch (error) { return []; }
  };
  const writeFavorites = (favorites) => {
    try { window.localStorage.setItem(storageKey, JSON.stringify(favorites)); } catch (error) {}
  };
  const hydrateFavoriteDetails = async () => {
    const favorites = readFavorites();
    const missing = favorites.filter(item => !item.title && item.handle);
    if (!missing.length) return;
    await Promise.all(missing.map(async item => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(item.handle)}.js`);
        if (!response.ok) return;
        const product = await response.json();
        item.title = product.title || item.handle;
        item.image = item.image || product.featured_image || (product.images && product.images[0]) || '';
        item.price = item.price || (product.price ? new Intl.NumberFormat(undefined, { style: 'currency', currency: 'AED' }).format(Number(product.price) / 100) : '');
        item.url = item.url || `/products/${encodeURIComponent(item.handle)}`;
      } catch (error) {}
    }));
    writeFavorites(favorites);
  };
  const escapeHtml = (value) => String(value || '').replace(/[&<>\"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[character]));
  const isSaved = (id) => readFavorites().some(item => String(item.id) === String(id));
  const updateCount = () => {
    const count = readFavorites().length;
    document.querySelectorAll('[data-favorites-count]').forEach(element => {
      element.textContent = count;
      element.hidden = count === 0;
    });
  };
  const syncButtons = () => {
    const favorites = readFavorites();
    document.querySelectorAll('[data-favorite-button]').forEach(button => {
      const saved = favorites.some(item => String(item.id) === String(button.dataset.productId));
      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Add'} ${button.dataset.productTitle || 'product'} ${saved ? 'from' : 'to'} favorites`);
      const icon = button.querySelector('[aria-hidden="true"]');
      if (icon) icon.textContent = saved ? '♥' : '♡';
    });
  };
  const renderFavoritesPage = () => {
    const page = document.querySelector('[data-favorites-page]');
    if (!page) return;
    const grid = page.querySelector('[data-favorites-grid]');
    const empty = page.querySelector('[data-favorites-empty]');
    const favorites = readFavorites();
    if (!favorites.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    grid.innerHTML = favorites.map(item => `<article class="pakshop-card"><a class="pakshop-card__link" href="${escapeHtml(item.url || '#')}"><div class="pakshop-card__media">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title || 'Product')}" loading="lazy">` : '<div class="pakshop-placeholder">Product image</div>'}<button class="pakshop-wishlist is-active" type="button" data-favorite-button data-product-id="${escapeHtml(item.id)}" data-product-handle="${escapeHtml(item.handle)}" data-product-title="${escapeHtml(item.title)}" data-product-url="${escapeHtml(item.url)}" data-product-image="${escapeHtml(item.image)}" data-product-price="${escapeHtml(item.price)}" aria-label="Remove ${escapeHtml(item.title || 'Product')} from favorites" aria-pressed="true"><span aria-hidden="true">♥</span></button></div><div class="pakshop-card__content"><h3 class="pakshop-card__title">${escapeHtml(item.title || 'Product')}</h3><div><span class="pakshop-card__price">${escapeHtml(item.price)}</span></div></div></a><a class="pakshop-btn pakshop-btn--green pakshop-card__buy" href="${escapeHtml(item.url || '#')}">Buy now</a></article>`).join('');
  };
  const renderFavoritesDrawer = () => {
    const drawer = document.querySelector('[data-favorites-drawer]');
    if (!drawer) return;
    const grid = drawer.querySelector('[data-favorites-drawer-grid]');
    const empty = drawer.querySelector('[data-favorites-drawer-empty]');
    const favorites = readFavorites();
    empty.hidden = favorites.length > 0;
    grid.innerHTML = favorites.map(item => `<article class="pakshop-favorite-item"><a href="${escapeHtml(item.url || '#')}" class="pakshop-favorite-item__link"><div class="pakshop-favorite-item__image">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title || 'Product')}" loading="lazy">` : '<div class="pakshop-placeholder">Product image</div>'}</div><div class="pakshop-favorite-item__details"><strong>${escapeHtml(item.title || 'Product')}</strong><span>${escapeHtml(item.price || 'View product')}</span></div></a><button type="button" class="pakshop-favorite-item__remove" data-favorite-button data-product-id="${escapeHtml(item.id)}" data-product-handle="${escapeHtml(item.handle)}" data-product-title="${escapeHtml(item.title)}" data-product-url="${escapeHtml(item.url)}" data-product-image="${escapeHtml(item.image)}" data-product-price="${escapeHtml(item.price)}" aria-label="Remove ${escapeHtml(item.title || 'Product')} from favorites">×</button></article>`).join('');
  };
  const setDrawerOpen = (open) => {
    const drawer = document.querySelector('[data-favorites-drawer]');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-favorites-toggle]').forEach(toggle => toggle.setAttribute('aria-expanded', open ? 'true' : 'false'));
    document.body.classList.toggle('pakshop-favorites-open', open);
    if (open) { renderFavoritesDrawer(); hydrateFavoriteDetails().then(() => { updateCount(); syncButtons(); renderFavoritesDrawer(); }); }
  };
  const toggleFavorite = (button) => {
    const product = { id: button.dataset.productId, handle: button.dataset.productHandle, title: button.dataset.productTitle, url: button.dataset.productUrl, image: button.dataset.productImage, price: button.dataset.productPrice };
    const favorites = readFavorites();
    const index = favorites.findIndex(item => String(item.id) === String(product.id));
    if (index >= 0) favorites.splice(index, 1); else favorites.unshift(product);
    writeFavorites(favorites);
    updateCount();
    syncButtons();
    renderFavoritesPage();
    renderFavoritesDrawer();
  };
  if (!document.documentElement.dataset.pakshopFavoritesReady) {
    document.documentElement.dataset.pakshopFavoritesReady = 'true';
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-favorite-button]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(button);
    });
    document.addEventListener('click', event => {
      const toggle = event.target.closest('[data-favorites-toggle]');
      if (toggle) { event.preventDefault(); setDrawerOpen(true); return; }
      if (event.target.closest('[data-favorites-close]')) { event.preventDefault(); setDrawerOpen(false); }
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') setDrawerOpen(false); });
    window.addEventListener('storage', () => { updateCount(); syncButtons(); renderFavoritesPage(); renderFavoritesDrawer(); });
  }
  updateCount();
  syncButtons();
  renderFavoritesPage();
  renderFavoritesDrawer();
  hydrateFavoriteDetails().then(() => { updateCount(); syncButtons(); renderFavoritesPage(); renderFavoritesDrawer(); });
}

function initPakshopInlineSearch(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-inline-search]').forEach((panel) => {
    if (panel.dataset.pakshopInlineSearchReady === 'true') return;
    const toggle = document.querySelector('[data-search-toggle]');
    const input = panel.querySelector('[data-inline-search-input]');
    const form = panel.querySelector('[data-inline-search-form]');
    const results = panel.querySelector('[data-inline-search-results]');
    if (!toggle || !input || !form || !results) return;

    panel.dataset.pakshopInlineSearchReady = 'true';
    let timer;
    let requestId = 0;
    const escapeHtml = (value) => String(value || '').replace(/[&<>\"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[character]));
    const close = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      results.innerHTML = '';
    };
    const open = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => input.focus(), 0);
    };
    const render = (products, term) => {
      if (!products.length) {
        results.innerHTML = `<p class="pakshop-inline-search__empty">No products found for “${escapeHtml(term)}”.</p>`;
        return;
      }
      results.innerHTML = products.map((product) => {
        const image = product.image || product.featured_image || '';
        const price = product.price || '';
        return `<a class="pakshop-inline-search__result" href="${escapeHtml(product.url || '#')}">${image ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">` : ''}<span><strong>${escapeHtml(product.title)}</strong>${price ? `<small>${escapeHtml(price)}</small>` : ''}</span></a>`;
      }).join('');
    };
    const fetchSuggestions = async (term) => {
      const currentRequest = ++requestId;
      const rootPath = window.Shopify?.routes?.root || '/';
      const endpoint = `${rootPath}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      try {
        const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Search suggestions failed: ${response.status}`);
        const data = await response.json();
        if (currentRequest !== requestId) return;
        render(data.resources?.results?.products || [], term);
      } catch (error) {
        if (currentRequest === requestId) results.innerHTML = '<p class="pakshop-inline-search__empty">Type a product name to search.</p>';
      }
    };

    toggle.addEventListener('click', () => (panel.hidden ? open() : close()));
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }
      results.innerHTML = '<p class="pakshop-inline-search__loading">Searching products…</p>';
      timer = window.setTimeout(() => fetchSuggestions(term), 220);
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const term = input.value.trim();
      if (term.length < 2) {
        results.innerHTML = '<p class="pakshop-inline-search__empty">Please enter a product name.</p>';
        input.focus();
        return;
      }
      results.innerHTML = '<p class="pakshop-inline-search__loading">Searching products…</p>';
      fetchSuggestions(term);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) close();
    });
    document.addEventListener('click', (event) => {
      if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) close();
    });
  });
}

function initPakshopReviewSliders(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-mobile-review-slider]').forEach((slider) => {
    if (slider.dataset.pakshopReviewSliderReady === 'true') return;
    const cards = Array.from(slider.children).filter((card) => card.classList.contains('pakshop-review'));
    if (cards.length < 2) return;
    slider.dataset.pakshopReviewSliderReady = 'true';
    let index = 0;
    let timer;
    let paused = false;
    const isMobile = () => window.matchMedia('(max-width: 720px)').matches;
    const goTo = (nextIndex) => {
      index = (nextIndex + cards.length) % cards.length;
      if (isMobile()) slider.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
    };
    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => {
        if (!paused && isMobile()) goTo(index + 1);
      }, 4500);
    };
    slider.addEventListener('mouseenter', () => { paused = true; });
    slider.addEventListener('mouseleave', () => { paused = false; });
    slider.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    slider.addEventListener('touchend', () => { paused = false; start(); }, { passive: true });
    window.addEventListener('resize', () => {
      if (!isMobile()) {
        index = 0;
        slider.scrollTo({ left: 0, behavior: 'auto' });
      }
    });
    start();
  });
}
function initPakshopCategoryFilters(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  const section = root.querySelector('.pakshop-trending-section');
  if (!section || section.dataset.pakshopFiltersReady === 'true') return;
  const grid = section.querySelector('.pakshop-product-grid');
  const pills = Array.from(section.querySelectorAll('[data-pakshop-category-filter]'));
  if (!grid || !pills.length) return;
  section.dataset.pakshopFiltersReady = 'true';
  const pageSize = 8;
  let activeProducts = [];
  let visibleCount = pageSize;
  let moreButton;
  const collectionCache = new Map();
  const escapeHtml = (value) => String(value || '').replace(/[&<>\"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[character]));
  const money = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? `Dhs. ${amount.toFixed(2)}` : 'Dhs. 0.00';
  };
  const productMarkup = (product, productIndex) => {
    const image = product.images?.[0]?.src || product.featured_image || '';
    const variant = product.variants?.[0];
    const price = variant?.price || 0;
    const compare = variant?.compare_at_price;
    const discountPercent = compare && Number(compare) > Number(price) ? Math.round((Number(compare) - Number(price)) * 100 / Number(compare)) : 0;
    const saleBadge = discountPercent > 0 ? `<span class="pakshop-sale">Save ${discountPercent}%</span>` : '';
    const ratingSeed = Number(product.id || 0) % 7;
    const ratings = ['4.9', '4.8', '4.8', '4.9', '4.8', '4.9', '4.8', '4.9'];
    // Keep the category/home cards in sync with the product-page social-proof snippet.
    // Both use the Shopify product ID modulo 7, so the sold count never changes
    // just because the product moves to a different position in a collection.
    const sold = ['3.9K', '2.5K', '1.8K', '1.2K', '2.7K', '4.3K', '1.6K'];
    const soldLabel = sold[ratingSeed];
    const variantId = variant?.id || '';
    const isAvailable = variant?.available !== false;
    const cartLabel = isAvailable ? 'Add to cart' : 'Sold out';
    return `<article class="pakshop-card"><a class="pakshop-card__link" data-product-link href="${escapeHtml(product.handle ? `/products/${product.handle}` : '#')}" onclick="window.location.assign(this.href); return false;"><div class="pakshop-card__media">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : '<div class="pakshop-placeholder">Product image</div>'}${saleBadge}</div><div class="pakshop-card__content"><h3 class="pakshop-card__title">${escapeHtml(product.title)}</h3><div class="pakshop-card__price-row"><span class="pakshop-card__price">${money(price)}</span>${compare ? `<span class="pakshop-card__compare">${money(compare)}</span>` : ''}</div><div class="pakshop-card__meta" aria-label="Rated ${ratings[ratingSeed]} out of 5, ${soldLabel} sold"><span class="pakshop-card__rating-pill"><span class="pakshop-card__stars" aria-hidden="true">★</span><strong>${ratings[ratingSeed]}</strong></span><span class="pakshop-card__sold-pill"><svg class="pakshop-card__sold-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 8.5h11l-.8 11H7.3l-.8-11Zm2.8 0V6.8a2.7 2.7 0 0 1 5.4 0v1.7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="pakshop-card__sold">${soldLabel} sold</span></span></div></div></a><form method="post" action="/cart/add" class="pakshop-card__cart-form"><input type="hidden" name="id" value="${escapeHtml(variantId)}"><input type="hidden" name="quantity" value="1"><button type="submit" class="pakshop-btn pakshop-btn--green pakshop-card__buy"${isAvailable ? '' : ' disabled'}>${cartLabel}</button></form></article>`;
  };
  const render = () => {
    if (moreButton) { moreButton.remove(); moreButton = null; }
    if (!activeProducts.length) {
      grid.innerHTML = '<p class="pakshop-inline-search__empty">No products found in this category.</p>';
      return;
    }
    grid.innerHTML = activeProducts.slice(0, visibleCount).map((product, productIndex) => productMarkup(product, productIndex)).join('');
    if (visibleCount < activeProducts.length) {
      moreButton = document.createElement('button');
      moreButton.type = 'button';
      moreButton.className = 'pakshop-btn pakshop-btn--dark pakshop-category-load-more';
      moreButton.textContent = 'Load more';
      moreButton.addEventListener('click', () => { visibleCount += pageSize; render(); });
      grid.insertAdjacentElement('afterend', moreButton);
    }
  };
  const load = async (pill) => {
    const url = pill.dataset.filterUrl || '';
    const match = url.match(/\/collections\/([^?#/]+)/);
    if (!match) return;
    const handle = match[1];
    pills.forEach((item) => { item.classList.toggle('is-active', item === pill); });
    if (moreButton) { moreButton.remove(); moreButton = null; }
    grid.setAttribute('aria-busy', 'true');
    if (collectionCache.has(handle)) {
      activeProducts = collectionCache.get(handle);
      visibleCount = pageSize;
      render();
      grid.removeAttribute('aria-busy');
      return;
    }
    grid.classList.add('is-loading');
    try {
      const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`, { headers: { Accept: 'application/json' }, cache: 'force-cache' });
      if (!response.ok) throw new Error('Collection products unavailable');
      const data = await response.json();
      activeProducts = data.products || [];
      collectionCache.set(handle, activeProducts);
      visibleCount = pageSize;
      render();
    } catch (error) {
      grid.innerHTML = '<p class="pakshop-inline-search__empty">Products could not be loaded right now.</p>';
    } finally { grid.classList.remove('is-loading'); grid.removeAttribute('aria-busy'); }
  };
  pills.forEach((pill) => pill.addEventListener('click', (event) => { event.preventDefault(); load(pill); }));
  const initial = pills.find((pill) => pill.classList.contains('is-active')) || pills[0];
  load(initial);
}

function initProductCardLinks(scope) {
  const root = scope?.addEventListener ? scope : document;
  if (root.dataset?.productCardLinksReady === 'true') return;
  if (root === document) document.documentElement.dataset.productCardLinksReady = 'true';
  root.addEventListener('click', (event) => {
    const link = event.target.closest?.('a.pakshop-card__link');
    if (!link || !link.href) return;
    if (event.target.closest('button, form, [data-favorite-button]')) return;
    event.preventDefault();
    window.location.assign(link.href);
  }, true);
}

function initPakshopCategoryCarousels(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-pakshop-category-carousel]').forEach((carousel) => {
    if (carousel.dataset.pakshopCarouselReady === 'true') return;

    const viewport = carousel.querySelector('.pakshop-categories__viewport');
    const track = carousel.querySelector('.pakshop-categories__track');
    const firstGroup = carousel.querySelector('.pakshop-categories__group:not(.pakshop-categories__group--clone)');
    if (!viewport || !track || !firstGroup) return;

    carousel.dataset.pakshopCarouselReady = 'true';
    carousel.addEventListener('click', (event) => {
      const link = event.target.closest('a.pakshop-category');
      if (!link || !link.href) return;
      if (window.Shopify?.designMode) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.top.location.assign(link.href);
      }
    }, true);
    track.style.removeProperty('transform');
    track.style.setProperty('animation', 'none', 'important');

    let loopWidth = 0;
    let lastTime = 0;
    let paused = false;
    let resumeTimer;
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScrollLeft = 0;
    let suppressClick = false;

    const measure = () => {
      loopWidth = firstGroup.getBoundingClientRect().width;
      if (loopWidth > 0 && viewport.scrollLeft >= loopWidth) viewport.scrollLeft %= loopWidth;
    };
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    const pauseBriefly = () => {
      paused = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(resume, 1800);
    };
    const speedSeconds = () => {
      const configured = parseFloat(getComputedStyle(carousel).getPropertyValue('--pakshop-category-speed'));
      return Number.isFinite(configured) && configured > 0 ? configured : 34;
    };

    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', resume);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', resume);
    viewport.addEventListener('touchstart', pauseBriefly, { passive: true });

    viewport.addEventListener('pointerdown', (event) => {
      // Leave desktop mouse clicks to the category anchors. Only touch/pointer
      // gestures should activate carousel dragging.
      if (event.pointerType === 'mouse') return;
      if (event.button !== 0) return;
      dragging = true;
      moved = false;
      suppressClick = false;
      startX = event.clientX;
      startScrollLeft = viewport.scrollLeft;
      paused = true;
      carousel.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 6) moved = true;
      viewport.scrollLeft = startScrollLeft - delta;
      if (moved) event.preventDefault();
    });
    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      suppressClick = moved;
      carousel.classList.remove('is-dragging');
      viewport.releasePointerCapture?.(event.pointerId);
      pauseBriefly();
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('click', (event) => {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }
    }, true);

    window.addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(firstGroup);

    const tick = (now) => {
      if (!lastTime) lastTime = now;
      const elapsed = Math.min(now - lastTime, 80);
      lastTime = now;
      if (!paused && !dragging && loopWidth > 0 && document.visibilityState !== 'hidden') {
        viewport.scrollLeft += (loopWidth / speedSeconds()) * (elapsed / 1000);
        if (viewport.scrollLeft >= loopWidth) viewport.scrollLeft %= loopWidth;
      }
    };

    measure();
    window.setInterval(() => tick(performance.now()), 16);
  });
}
function initPakshopAnnouncementTickers(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-pakshop-announcement]').forEach((bar) => {
    if (bar.dataset.pakshopAnnouncementReady === 'true') return;

    const track = bar.querySelector('.pakshop-announcement__track');
    const firstGroup = bar.querySelector('.pakshop-announcement__group:not(.pakshop-announcement__group--clone)');
    if (!track || !firstGroup) return;

    bar.dataset.pakshopAnnouncementReady = 'true';
    track.style.setProperty('animation', 'none', 'important');

    let loopWidth = 0;
    let distance = 0;
    let lastTime = 0;
    let paused = false;
    let resumeTimer;

    const measure = () => {
      loopWidth = firstGroup.getBoundingClientRect().width;
      if (loopWidth > 0) distance %= loopWidth;
    };
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };
    const pauseForTouch = () => {
      paused = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(resume, 2500);
    };
    const speedSeconds = () => {
      const configured = parseFloat(getComputedStyle(bar).getPropertyValue('--pakshop-announcement-speed'));
      return Number.isFinite(configured) && configured > 0 ? configured : 28;
    };
    const tick = (now) => {
      if (!lastTime) lastTime = now;
      const elapsed = Math.min(now - lastTime, 80);
      lastTime = now;
      if (!paused && loopWidth > 0 && document.visibilityState !== 'hidden') {
        distance += (loopWidth / speedSeconds()) * (elapsed / 1000);
        if (distance >= loopWidth) distance %= loopWidth;
        track.style.transform = `translate3d(${-distance}px, 0, 0)`;
      }
    };

    bar.addEventListener('mouseenter', pause);
    bar.addEventListener('mouseleave', resume);
    bar.addEventListener('focusin', pause);
    bar.addEventListener('focusout', resume);
    bar.addEventListener('touchstart', pauseForTouch, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(firstGroup);
    measure();
    window.setInterval(() => tick(performance.now()), 16);
  });
}

function initPakshopCartLiveUpdates(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-cart-form]').forEach((form) => {
    if (form.dataset.pakshopLiveCartReady === 'true') return;
    form.dataset.pakshopLiveCartReady = 'true';

    form.querySelectorAll('[data-cart-line][data-cart-product-url]').forEach((line) => {
      if (line.dataset.pakshopProductLinkReady === 'true') return;
      line.dataset.pakshopProductLinkReady = 'true';
      line.addEventListener('click', (event) => {
        if (event.target.closest('button, input, a, select, textarea, label')) return;
        const url = line.dataset.cartProductUrl;
        if (url) window.location.assign(url);
      });
    });

    const total = form.querySelector('[data-cart-total]');
    const currency = form.dataset.currencyLabel || 'Dhs.';
    const formatMoney = (cents) => `${currency} ${(Number(cents || 0) / 100).toFixed(2)}`;

    form.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') return;
      const discountCode = form.dataset.buy2DiscountCode;
      const hasBuy2Line = Array.from(form.querySelectorAll('[data-cart-quantity]')).some((input) => Number(input.value) >= 2);
      if (!discountCode || !hasBuy2Line) return;
      event.preventDefault();
      window.location.assign(`/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`);
    });

    form.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      input.addEventListener('change', async () => {
        if (input.dataset.updating === 'true') return;
        const previous = Math.max(1, parseInt(input.dataset.previous || input.defaultValue || input.value || '1', 10));
        const quantity = Math.min(99, Math.max(1, parseInt(input.value || '1', 10)));
        input.value = quantity;
        input.dataset.updating = 'true';
        input.setAttribute('aria-busy', 'true');
        const control = input.closest('[data-quantity]');
        control?.querySelectorAll('button').forEach((button) => { button.disabled = true; });

        const rootPath = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(`${rootPath}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: Number(input.dataset.line), quantity })
          });
          if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);
          const cart = await response.json();
          const lineItem = cart.items?.[Number(input.dataset.line) - 1];
          const line = input.closest('[data-cart-line]');
          const linePrice = line?.querySelector('[data-line-price]');
          if (lineItem) {
            input.value = lineItem.quantity;
            input.dataset.previous = lineItem.quantity;
            if (linePrice) linePrice.textContent = formatMoney(lineItem.final_line_price);
          } else {
            input.value = quantity;
            input.dataset.previous = quantity;
          }
          if (total) total.textContent = formatMoney(cart.total_price);
          document.querySelectorAll('.pakshop-cart-count').forEach((count) => { count.textContent = cart.item_count; });
        } catch (error) {
          input.value = previous;
          input.dataset.previous = previous;
          window.setTimeout(() => window.location.reload(), 50);
        } finally {
          input.dataset.updating = 'false';
          input.removeAttribute('aria-busy');
          control?.querySelectorAll('button').forEach((button) => { button.disabled = false; });
        }
      });
      input.dataset.previous = input.value;
    });
  });
}

function initPakshopCartRemoveButtons(scope) {
  const root = scope?.querySelectorAll ? scope : document;
  root.querySelectorAll('[data-cart-remove]').forEach((link) => {
    if (link.dataset.pakshopRemoveReady === 'true') return;
    link.dataset.pakshopRemoveReady = 'true';

    link.addEventListener('click', async (event) => {
      event.preventDefault();
      if (link.dataset.removing === 'true') return;
      link.dataset.removing = 'true';
      link.setAttribute('aria-disabled', 'true');
      link.textContent = 'Removing…';
      const line = link.closest('[data-cart-line]');
      if (line) {
        line.setAttribute('aria-busy', 'true');
        line.hidden = true;
      }

      const rootPath = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${rootPath}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(link.dataset.line), quantity: 0 })
        });
        if (!response.ok) throw new Error(`Cart removal failed: ${response.status}`);
        window.location.reload();
      } catch (error) {
        window.location.href = link.href;
      }
    });
  });
}

if (window.Shopify) {
  document.addEventListener('shopify:section:load', (event) => {
    initPakshopButtonMotion(event.target);
    initPakshopCategoryCarousels(event.target);
    initPakshopReviewSliders(event.target);
    initPakshopAnnouncementTickers(event.target);
    initPakshopCartRemoveButtons(event.target);
    initPakshopCartLiveUpdates(event.target);
    initPakshopFavorites(event.target);
  });
}



initProductCardLinks();
